import React, { useContext, useEffect, useState } from "react";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import DateForm from "../../Components/DateForm/DateForm";
import InputForm from "../../Components/InputForm/InputForm";
import SelectForm from "../../Components/SelectForm/SelectForm";
import { useLocation, useNavigate } from "react-router-dom";
import { APICall, HttpMethod } from "../../Helpers/Network/APICalls";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import ButtonForm from "../../Components/ButtonForm/ButtonForm";
import ButtonComponent from "../../Components/ButtonForm/Button";
import ApprovalModal from "../Common/ApprovalModal/ApprovalModal";
import { RiFileListLine } from "react-icons/ri";
import { Modules } from "../../Helpers/Enums/Modules";
import { GetDecryptedMemberIdFromLocalStorage } from "../../Helpers/CommonFunctions/EncryptedMemberIdFunction";
import { DATE_DISPLAY_FORMAT } from "../../Helpers/Constants/Constants";
import moment from "moment";
import { loanModuleGetPersonalDetailsByMemberId } from "../../Helpers/APIEndPoints/EndPoints";
import { useSelector } from "react-redux";
import { LoanStatus } from "../../Helpers/Enums/ApplicationStatus";

const PersonalApproval = (props: any) => {
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const { state } = useLocation();
  let navigate = useNavigate();
  const [disabled, setDisabled] = useState(true);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const [data, setData] = useState({
    MemberId: 0,
    MemberNo: 0,
    FirstName: "",
    MiddleName: "",
    LastName: "",
    ResidentialAddress: "",
    ContactNumber: 0,
    EmailId: "",
    DateOfBirth: "",
    DateOfJoining: "",
    DateOfConfirmation: "",
    StatusId: 0,
  });
  const loanParameters = useSelector<any>(
    (state) => state?.LoanModuleReducer?.loanParameters
  );
  const [AdditionalLoanParameter, setAdditionalLoanParameter] = useState<any>({
    LoanId: "0",
  });

  const open = Boolean(anchorEl);

  useEffect(() => {
    getPersonalDetailsByIdApiCallll();
  }, []);

  const getPersonalDetailsByIdApiCallll = async () => {
    showLoader();
    let requestParams = loanParameters; // { MemberId: MemberId };
    const res = await APICall(
      loanModuleGetPersonalDetailsByMemberId,
      requestParams
    );
    if (res.Message === "Ok" && res.Data !== null) {
    

      setAdditionalLoanParameter({
        ...AdditionalLoanParameter,
        LoanId: loanParameters?.["LoanId"],
        MemberId: loanParameters?.["MemberId"],
      });

      setData({
        ...data,
        MemberNo: res?.Data?.MemberNo,
        FirstName: res?.Data?.FirstName,
        MiddleName: res?.Data?.MiddleName,
        LastName: res?.Data?.LastName,
        ResidentialAddress: res?.Data?.ResidentialAddress,
        ContactNumber: res?.Data?.MobileNumber,
        EmailId: res?.Data?.EmailId,
        DateOfBirth: res?.Data?.DOB,
        DateOfJoining: res?.Data?.DOJ,
        DateOfConfirmation: res?.Data?.DOC,
        StatusId: res?.Data?.Lrd_StatusId,
      });

      hideLoader();
    } else {
      notify(ToastType.Error, "Data not found");
      hideLoader();
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div className="clearfix"></div>

      <div className="col-lg-12 col-md-12 mt-3">
        <div className="row">
          <div className="col-lg-4 col-sm-4 col-xs-4"></div>
          <div
            className="col-lg-4 col-sm-4 col-xs-4"
            style={{ textAlign: "center" }}
          >
            Member No.{" " + data.MemberNo}
          </div>
          <div className="col-lg-4 col-sm-4 col-xs-4"></div>
        </div>
      </div>
      <div className="p-0">
        <div className="col-lg-12 col-md-12">
          <div className="row" style={{ marginLeft: "-30px", marginRight: "-30px" }}>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>First Name</label>
                <InputForm
                  placeholder={""}
                  value={data?.FirstName}
                  isDisabled={disabled}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Middle Name</label>
                <InputForm
                  placeholder={""}
                  value={data?.MiddleName}
                  isDisabled={disabled}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Last Name</label>
                <InputForm
                  placeholder={""}
                  value={data?.LastName}
                  isDisabled={disabled}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-12 col-md-12 mt-2">
          <div className="row" style={{ marginLeft: "-30px", marginRight: "-30px" }}>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Residential Address</label>
                <InputForm
                  placeholder={""}
                  value={data?.ResidentialAddress}
                  textArea={true}
                  type="text"
                  isDisabled={true}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Contact Number</label>
                <InputForm
                  placeholder={""}
                  value={data?.ContactNumber}
                  type="number"
                  isDisabled={true}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Email Id</label>
                <InputForm
                  placeholder={""}
                  value={data?.EmailId}
                  type="text"
                  isDisabled={true}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-12 col-md-12 mt-2">
          <div className="row" style={{ marginLeft: "-30px", marginRight: "-30px" }}>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Date of Birth</label>
                <InputForm
                  placeholder={""}
                  value={
                    moment(data?.DateOfBirth).isValid()
                      ? moment(data?.DateOfBirth).format(DATE_DISPLAY_FORMAT)
                      : ""
                  }
                  type="text"
                  isDisabled={true}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Date of Joining</label>
                <InputForm
                  placeholder={""}
                  value={
                    moment(data?.DateOfJoining).isValid()
                      ? moment(data?.DateOfJoining).format(DATE_DISPLAY_FORMAT)
                      : ""
                  }
                  type="text"
                  isDisabled={true}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-xs-4">
              <div className="form-group">
                <label>Date of Confirmation</label>
                <InputForm
                  placeholder={""}
                  value={
                    moment(data?.DateOfConfirmation).isValid()
                      ? moment(data?.DateOfConfirmation).format(
                          DATE_DISPLAY_FORMAT
                        )
                      : ""
                  }
                  type="text"
                  isDisabled={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end mt-4">
        <div>
          <ButtonForm
            className="mx-2"
            id="cancel"
            value={<p><i className="far fa-times-circle"></i> Cancel</p> }
            onClick={() => navigate("/LoanApprovalDashboard")}
          />
          {state?.action !== "View" ? (
            <ButtonComponent
              icon={"fas fa-check-double"}
              value={"Verify"}
              style={{ marginLeft: "10px" }}
              id={"saveBtn"}
              onClick={handleClick}
            >
              
            </ButtonComponent>
          ) : (
            ""
          )}
        </div>
      </div>
      <>
        <ApprovalModal
          open={open}
          anchorEl={anchorEl}
          handleClose={handleClose}
          loanParam={AdditionalLoanParameter}
          module={
            data?.StatusId ===
            LoanStatus.LoanModule_LoanCommitteeApprovalPending
              ? Modules.LoanCommitteeApproval1
              : Modules.LoanCommitteeApproval2
          }
        />
      </>
    </>
  );
};

export default PersonalApproval;
